import { Image as ImageType, Maybe, MenuItemType } from '@shopify/hydrogen/storefront-api-types'
import { Image, Link } from '@shopify/hydrogen'
import { useContext } from 'react'
import styles from '../../assets/scss/components/mobile-menu.module.scss'
import { EnhancedMenu } from '../../lib/menus'
import { HeaderContext } from '../header/header-provider.client'
import { useI18n } from '../i18n.client'
import { kebabCase } from 'lodash'

export const ChildMenu: React.FC<{ menu: EnhancedMenu }> = ({ menu }) => {
  const { activeMobileParentMenuIndex, setActiveMobileParentMenuIndex, setIsMainNavigationOpen } =
    useContext(HeaderContext)
  const [i18n] = useI18n()

  const handleClick = () => {
    setIsMainNavigationOpen(false)

    setTimeout(() => {
      setActiveMobileParentMenuIndex(undefined)
    }, 400)
  }

  if (activeMobileParentMenuIndex === undefined) {
    return null
  }

  return (
    <div className={styles.childMenu}>
      <div className={styles.header}>
        <div onClick={() => setActiveMobileParentMenuIndex(undefined)}>{i18n.translate('back')}</div>
        {i18n.translate(kebabCase(menu.items[activeMobileParentMenuIndex].title))}
        <div onClick={handleClick}>{i18n.translate('close')}</div>
      </div>
      <div className={styles.scrollContainer}>
        <div className={styles.grid}>
          {menu.items.map(
            ({ items }, index) =>
              index === activeMobileParentMenuIndex &&
              items.map(({ id, image, title, to, type }) => (
                <Link className={styles.menuItem} key={id} onClick={handleClick} to={to}>
                  <MenuItemImage image={image} />
                  <div className={styles.menuItemTitle}>{title}</div>
                </Link>
              )),
          )}
        </div>
      </div>
    </div>
  )
}

const MenuItemImage: React.FC<{ image?: Maybe<ImageType> }> = ({ image }) => {
  if (image) {
    return (
      <Image alt={image.altText ?? ''} height={image.height ?? 'auto'} src={image.url} width={image.width ?? 'auto'} />
    )
  }

  return <Image alt="" height="640" src="https://dummyimage.com/422x640" width="422" />
}
